/**
 * Helpers liés au DTO SchedulerStatus, partagés entre OpsScreen et OverviewScreen.
 */

/**
 * Normalise la valeur brute de `quotaRemaining` en provenance du backend.
 *
 * - `null`/`undefined` : aucune mesure persistée (premier boot, base vide).
 * - `< 0` : sentinelle interne backend (héritée d'une version pré-normalisation
 *   ou si le DTO échouait à traduire l'`AtomicLong(-1)`). On garde la garde
 *   en defense-in-depth pour ne jamais afficher un nombre négatif à l'utilisateur.
 *
 * Tous les call-sites doivent passer par cette fonction pour que la sémantique
 * "indisponible" reste cohérente (badge `—`, pas de warn rouge).
 */
export function normalizeQuotaRemaining(raw: number | null | undefined): number | null {
  if (raw == null) return null;
  if (raw < 0) return null;
  return raw;
}
